import { BaseDto } from './base.dto';

export class ProductStockDto extends BaseDto {
  productStockName: string;
  supplierId: number;
  description: string;
  unitQuantity: number;
  weightQuantity: number;
}
